var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadcastNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 380,
    viewBox: "0 0 346 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17876_123538)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17876_123538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8184 31.6654C57.8184 22.9208 64.9072 15.832 73.6517 15.832H224.86C233.605 15.832 240.693 22.9208 240.693 31.6654V79.1653C240.693 87.9101 233.605 94.9987 224.86 94.9987H73.6517C64.9072 94.9987 57.8184 87.9101 57.8184 79.1653V31.6654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0792 33.3532C77.7406 32.8909 78.7378 32.9795 79.3317 33.4701L78.6505 32.4799C78.1023 31.6982 78.2987 30.8523 79.0812 30.3034C79.8637 29.7566 82.081 31.2266 82.081 31.2266C81.5276 30.4371 81.6314 29.4364 82.4206 28.8826C83.2107 28.3309 84.3001 28.5216 84.8526 29.3125L92.1859 39.6711L91.2509 48.7313L83.4522 45.8869L76.6492 35.8007C76.0912 35.0062 76.284 33.9105 77.0792 33.3532Z",
    fill: "#EF9645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5535 39.1156C75.5535 39.1156 74.7569 37.9545 75.9187 37.1586C77.0791 36.3627 77.875 37.5231 77.875 37.5231L81.5705 42.9121C81.6972 42.6996 81.8365 42.4899 81.9924 42.283L76.8638 34.8047C76.8638 34.8047 76.0679 33.6443 77.229 32.8484C78.3894 32.0525 79.1853 33.213 79.1853 33.213L84.0088 40.2479C84.1885 40.1015 84.3722 39.9544 84.5614 39.8102L78.9692 31.6535C78.9692 31.6535 78.1734 30.4931 79.3345 29.6972C80.4946 28.9013 81.291 30.0617 81.291 30.0617L86.8834 38.217C87.0884 38.091 87.2919 37.982 87.4961 37.8665L82.2687 30.244C82.2687 30.244 81.4731 29.0836 82.6337 28.2877C83.7935 27.4918 84.5899 28.6522 84.5899 28.6522L90.1165 36.7124L90.9565 37.9383C87.4747 40.3266 87.1438 44.8198 89.1325 47.7212C89.5307 48.3017 90.111 47.9042 90.111 47.9042C87.7233 44.4215 88.4524 40.5082 91.935 38.1206L90.9082 32.9821C90.9082 32.9821 90.525 31.6282 91.878 31.244C93.2317 30.8604 93.6165 32.2143 93.6165 32.2143L94.8016 35.7357C95.2719 37.1319 95.7722 38.5231 96.4348 39.839C98.3039 43.5546 97.1877 48.1723 93.6616 50.5909C89.8165 53.2276 84.559 52.2474 81.9212 48.4023L75.5535 39.1156Z",
    fill: "#FFDC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0942 49.4615C79.2791 49.4615 76.4348 46.6171 76.4348 43.8023C76.4348 43.4132 76.1498 43.0986 75.7606 43.0986C75.3714 43.0986 75.0273 43.4132 75.0273 43.8023C75.0273 48.0245 77.8717 50.8689 82.0942 50.8689C82.4829 50.8689 82.7979 50.5248 82.7979 50.1357C82.7979 49.7465 82.4829 49.4615 82.0942 49.4615Z",
    fill: "#5DADEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5841 50.8378C76.4731 50.8378 75.0656 49.4304 75.0656 47.3193C75.0656 46.9302 74.751 46.6156 74.3619 46.6156C73.9727 46.6156 73.6582 46.9302 73.6582 47.3193C73.6582 50.1341 75.7693 52.2452 78.5841 52.2452C78.9733 52.2452 79.2878 51.9307 79.2878 51.5415C79.2878 51.1523 78.9733 50.8378 78.5841 50.8378ZM90.5468 28.3193C90.1589 28.3193 89.843 28.6346 89.843 29.023C89.843 29.4114 90.1589 29.7267 90.5468 29.7267C93.362 29.7267 96.1764 32.2523 96.1764 35.3564C96.1764 35.7448 96.4922 36.06 96.8802 36.06C97.2689 36.06 97.584 35.7448 97.584 35.3564C97.584 31.4761 94.7696 28.3193 90.5468 28.3193Z",
    fill: "#5DADEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0554 26.9463C93.6666 26.9463 93.3516 27.2319 93.3516 27.6204C93.3516 28.0089 93.6666 28.3536 94.0554 28.3536C96.1659 28.3536 97.5442 29.9194 97.5442 31.8426C97.5442 32.2311 97.8886 32.5463 98.2773 32.5463C98.6668 32.5463 98.9518 32.2311 98.9518 31.8426C98.9518 29.1425 96.8697 26.9463 94.0554 26.9463Z",
    fill: "#5DADEC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M219.325 58.582H78.4082C75.7849 58.582 73.6582 60.7087 73.6582 63.332C73.6582 65.9554 75.7849 68.082 78.4082 68.082H219.325C221.948 68.082 224.075 65.9554 224.075 63.332C224.075 60.7087 221.948 58.582 219.325 58.582Z",
    fill: "#E2E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M117.992 74.4131H78.4082C75.7848 74.4131 73.6582 76.5397 73.6582 79.1631C73.6582 81.7864 75.7848 83.9131 78.4082 83.9131H117.992C120.615 83.9131 122.742 81.7864 122.742 79.1631C122.742 76.5397 120.615 74.4131 117.992 74.4131Z",
    fill: "#E2E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M201.117 74.4131H130.658C128.035 74.4131 125.908 76.5397 125.908 79.1631C125.908 81.7864 128.035 83.9131 130.658 83.9131H201.117C203.74 83.9131 205.867 81.7864 205.867 79.1631C205.867 76.5397 203.74 74.4131 201.117 74.4131Z",
    fill: "#E2E8EF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_17876_123538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.652 107.667H173.402C163.346 107.667 155.193 115.819 155.193 125.875C155.193 135.932 163.346 144.084 173.402 144.084H187.652C197.708 144.084 205.86 135.932 205.86 125.875C205.86 115.819 197.708 107.667 187.652 107.667Z",
    fill: "#D8FDD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.033 125.872C190.033 131.118 185.78 135.372 180.533 135.372C175.287 135.372 171.033 131.118 171.033 125.872C171.033 120.626 175.287 116.372 180.533 116.372C185.78 116.372 190.033 120.626 190.033 125.872Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.531 127.91C178.966 127.91 177.927 127.727 176.642 127.477C176.348 127.421 175.777 127.477 175.777 128.342C175.777 130.07 177.764 132.231 180.531 132.231C183.299 132.231 185.285 130.07 185.285 128.342C185.285 127.477 184.714 127.421 184.421 127.477C183.136 127.727 182.097 127.91 180.531 127.91Z",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.821 118.107C179.368 116.824 177.962 116.151 176.678 116.603C175.899 116.877 175.348 117.506 175.132 118.241C174.504 117.804 173.68 117.66 172.903 117.935C171.62 118.388 170.946 119.795 171.399 121.079C171.464 121.26 171.549 121.429 171.648 121.584C172.678 123.474 175.653 124.803 177.454 124.82C178.846 123.676 180.329 120.775 179.944 118.657C179.924 118.473 179.885 118.289 179.821 118.107ZM181.246 118.107C181.7 116.824 183.107 116.151 184.39 116.603C185.169 116.877 185.72 117.506 185.935 118.241C186.564 117.804 187.387 117.66 188.165 117.935C189.448 118.388 190.122 119.795 189.67 121.079C189.605 121.26 189.52 121.429 189.42 121.584C188.39 123.474 185.415 124.803 183.613 124.82C182.222 123.676 180.74 120.775 181.124 118.657C181.143 118.473 181.183 118.289 181.246 118.107Z",
    fill: "#DD2E44"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_17876_123538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.652 107.667H230.402C220.346 107.667 212.193 115.819 212.193 125.875C212.193 135.932 220.346 144.084 230.402 144.084H244.652C254.708 144.084 262.86 135.932 262.86 125.875C262.86 115.819 254.708 107.667 244.652 107.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.024 125.871C246.024 130.566 242.218 134.371 237.524 134.371C232.83 134.371 229.023 130.566 229.023 125.871C229.023 121.177 232.83 117.371 237.524 117.371C242.218 117.371 246.024 121.177 246.024 125.871Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.522 125.128C235.522 126.095 234.962 126.878 234.272 126.878C233.581 126.878 233.021 126.095 233.021 125.128C233.021 124.162 233.581 123.378 234.272 123.378C234.962 123.378 235.522 124.162 235.522 125.128Z",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.031 125.128C242.031 126.095 241.472 126.878 240.781 126.878C240.091 126.878 239.531 126.095 239.531 125.128C239.531 124.162 240.091 123.378 240.781 123.378C241.472 123.378 242.031 124.162 242.031 125.128Z",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.032 129.876H234.032C233.755 129.876 233.531 129.652 233.531 129.375C233.531 129.099 233.755 128.875 234.032 128.875H241.032C241.308 128.875 241.532 129.099 241.532 129.375C241.532 129.652 241.308 129.876 241.032 129.876Z",
    fill: "#664500"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_17876_123538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.652 107.667H287.402C277.346 107.667 269.193 115.819 269.193 125.875C269.193 135.932 277.346 144.084 287.402 144.084H301.652C311.708 144.084 319.86 135.932 319.86 125.875C319.86 115.819 311.708 107.667 301.652 107.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.024 125.871C303.024 130.566 299.218 134.371 294.524 134.371C289.83 134.371 286.023 130.566 286.023 125.871C286.023 121.177 289.83 117.371 294.524 117.371C299.218 117.371 303.024 121.177 303.024 125.871Z",
    fill: "#DA2F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.266 131.812C298.243 131.723 297.682 129.623 294.524 129.623C291.365 129.623 290.803 131.723 290.781 131.812C290.753 131.92 290.802 132.033 290.9 132.089C290.997 132.144 291.119 132.129 291.199 132.051C291.209 132.042 292.176 131.122 294.524 131.122C296.871 131.122 297.839 132.042 297.848 132.051C297.896 132.098 297.96 132.123 298.024 132.123C298.066 132.123 298.108 132.112 298.147 132.091C298.245 132.034 298.294 131.921 298.266 131.812Z",
    fill: "#292F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.38 125.519C291.753 123.892 289.137 123.873 289.027 123.873C288.751 123.873 288.527 124.096 288.527 124.373C288.527 124.648 288.751 124.872 289.026 124.873C289.041 124.873 289.989 124.884 291.018 125.241C290.721 125.561 290.527 126.058 290.527 126.623C290.527 127.59 291.086 128.373 291.777 128.373C292.467 128.373 293.026 127.59 293.026 126.623C293.026 126.535 293.017 126.453 293.008 126.369C293.015 126.369 293.021 126.373 293.026 126.373C293.155 126.373 293.283 126.324 293.38 126.226C293.576 126.031 293.576 125.714 293.38 125.519Z",
    fill: "#292F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.023 123.873C299.913 123.873 297.299 123.892 295.67 125.519C295.475 125.714 295.475 126.031 295.67 126.226C295.767 126.324 295.896 126.373 296.024 126.373C296.03 126.373 296.036 126.369 296.041 126.369C296.033 126.453 296.024 126.535 296.024 126.623C296.024 127.59 296.583 128.373 297.274 128.373C297.964 128.373 298.524 127.59 298.524 126.623C298.524 126.058 298.329 125.561 298.032 125.241C299.062 124.884 300.01 124.873 300.025 124.873C300.301 124.872 300.524 124.648 300.523 124.373C300.523 124.096 300.3 123.873 300.023 123.873Z",
    fill: "#292F33"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_17876_123538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8184 172.581C57.8184 163.837 64.9072 156.748 73.6517 156.748H152.818C161.563 156.748 168.652 163.837 168.652 172.581V188.415C168.652 197.159 161.563 204.248 152.818 204.248H73.6517C64.9072 204.248 57.8184 197.159 57.8184 188.415V172.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M148.075 167.828H78.4082C75.7848 167.828 73.6582 169.955 73.6582 172.578C73.6582 175.201 75.7848 177.328 78.4082 177.328H148.075C150.698 177.328 152.825 175.201 152.825 172.578C152.825 169.955 150.698 167.828 148.075 167.828Z",
    fill: "#E2E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M127.492 183.668H78.4082C75.7849 183.668 73.6582 185.795 73.6582 188.418C73.6582 191.041 75.7849 193.168 78.4082 193.168H127.492C130.115 193.168 132.242 191.041 132.242 188.418C132.242 185.795 130.115 183.668 127.492 183.668Z",
    fill: "#E2E8EF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_17876_123538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4818 264.415C51.4818 257.419 45.8107 251.748 38.8151 251.748C31.8195 251.748 26.1484 257.419 26.1484 264.415C26.1484 271.41 31.8195 277.081 38.8151 277.081C45.8107 277.081 51.4818 271.41 51.4818 264.415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1665 260.667H39.8332C42.1902 260.667 43.3687 260.667 44.1009 261.399C44.8332 262.131 44.8332 263.31 44.8332 265.667C44.8332 268.024 44.8332 269.202 44.1009 269.935C43.3687 270.667 42.1902 270.667 39.8332 270.667H38.9998C38.9998 270.667 38.5832 272.334 35.6665 272.334C35.6665 272.334 36.4998 271.493 36.4998 270.653C35.2053 270.614 34.4332 270.469 33.8987 269.935C33.1665 269.202 33.1665 268.024 33.1665 265.667C33.1665 263.31 33.1665 262.131 33.8987 261.399C34.631 260.667 35.8095 260.667 38.1665 260.667Z",
    stroke: "#6940F2",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8335 263.583H45.2502C46.029 263.583 46.4184 263.583 46.7085 263.751C46.8985 263.86 47.0563 264.018 47.166 264.208C47.3335 264.498 47.3335 264.888 47.3335 265.666C47.3335 266.445 47.3335 266.835 47.166 267.125C47.0563 267.315 46.8985 267.473 46.7085 267.582C46.4184 267.75 46.029 267.75 45.2502 267.75H44.8335",
    stroke: "#6940F2",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1665 263.583H32.7498C31.971 263.583 31.5816 263.583 31.2915 263.751C31.1015 263.86 30.9437 264.018 30.834 264.208C30.6665 264.498 30.6665 264.888 30.6665 265.666C30.6665 266.445 30.6665 266.835 30.834 267.125C30.9437 267.315 31.1015 267.473 31.2915 267.582C31.5816 267.75 31.971 267.75 32.7498 267.75H33.1665",
    stroke: "#6940F2",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.25 256.917C40.25 257.607 39.6903 258.167 39 258.167C38.3097 258.167 37.75 257.607 37.75 256.917C37.75 256.227 38.3097 255.667 39 255.667C39.6903 255.667 40.25 256.227 40.25 256.917Z",
    stroke: "#6940F2",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 258.167V260.667",
    stroke: "#6940F2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 264V264.833M41.5 264V264.833",
    stroke: "#6940F2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3335 267.75C37.3335 267.75 37.8891 268.167 39.0002 268.167C40.1112 268.167 40.6668 267.75 40.6668 267.75",
    stroke: "#6940F2",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_17876_123538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8184 229.581C57.8184 220.837 64.9072 213.748 73.6517 213.748H198.735C207.48 213.748 214.568 220.837 214.568 229.581V261.248C214.568 269.993 207.48 277.081 198.735 277.081H60.985C59.2362 277.081 57.8184 275.664 57.8184 273.915V229.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M187.658 224.828H78.4082C75.7849 224.828 73.6582 226.955 73.6582 229.578C73.6582 232.201 75.7849 234.328 78.4082 234.328H187.658C190.282 234.328 192.408 232.201 192.408 229.578C192.408 226.955 190.282 224.828 187.658 224.828Z",
    fill: "#E2E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M124.325 240.668H78.4082C75.7849 240.668 73.6582 242.795 73.6582 245.418C73.6582 248.041 75.7849 250.168 78.4082 250.168H124.325C126.948 250.168 129.075 248.041 129.075 245.418C129.075 242.795 126.948 240.668 124.325 240.668Z",
    fill: "#E2E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M193.979 240.668H136.979C134.355 240.668 132.229 242.795 132.229 245.418C132.229 248.041 134.355 250.168 136.979 250.168H193.979C196.602 250.168 198.729 248.041 198.729 245.418C198.729 242.795 196.602 240.668 193.979 240.668Z",
    fill: "#E2E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M178.95 256.498H78.4082C75.7849 256.498 73.6582 258.625 73.6582 261.248C73.6582 263.871 75.7849 265.998 78.4082 265.998H178.95C181.573 265.998 183.7 263.871 183.7 261.248C183.7 258.625 181.573 256.498 178.95 256.498Z",
    fill: "#E2E8EF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_17876_123538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.693 300.831C259.693 292.087 266.782 284.998 275.527 284.998H304.027C312.771 284.998 319.86 292.087 319.86 300.831V341.998C319.86 343.747 318.442 345.165 316.693 345.165H275.527C266.782 345.165 259.693 338.076 259.693 329.331V300.831Z",
    fill: "#D8FDD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.193 315.013C303.193 314.615 303.098 314.241 302.939 313.902C301.878 310.477 296.907 310.727 289.838 310.56C288.656 310.532 289.332 309.137 289.747 306.073C290.017 304.08 288.732 301.021 286.572 301.021C283.011 301.021 286.437 303.829 283.288 310.775C281.606 314.487 277.846 312.408 277.846 316.136V324.622C277.846 326.073 277.988 327.468 280.029 327.697C282.008 327.92 281.563 329.33 284.417 329.33H298.701C300.156 329.33 301.34 328.145 301.34 326.69C301.34 326.087 301.129 325.538 300.787 325.093C301.595 324.641 302.149 323.787 302.149 322.798C302.149 322.196 301.939 321.647 301.598 321.202C302.408 320.751 302.964 319.897 302.964 318.906C302.964 318.186 302.672 317.534 302.203 317.057C302.802 316.573 303.193 315.841 303.193 315.013Z",
    fill: "#FFDB5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.752 317.651H300.564C301.49 317.651 302.359 317.156 302.833 316.358C303.028 316.03 302.919 315.605 302.59 315.409C302.261 315.214 301.836 315.324 301.641 315.652C301.417 316.032 301.003 316.266 300.563 316.266H293.589C292.897 316.266 292.335 315.704 292.335 315.013C292.335 314.322 292.897 313.759 293.589 313.759H298.249C298.632 313.759 298.942 313.449 298.942 313.067C298.942 312.684 298.632 312.374 298.249 312.374H293.588C292.133 312.374 290.949 313.558 290.949 315.013C290.949 315.824 291.325 316.542 291.903 317.027C291.416 317.506 291.113 318.171 291.113 318.905C291.113 319.719 291.492 320.44 292.073 320.923C291.589 321.401 291.289 322.064 291.289 322.797C291.289 323.684 291.731 324.466 292.404 324.945C291.989 325.411 291.73 326.018 291.73 326.69C291.73 328.145 292.913 329.328 294.368 329.328H298.71C299.636 329.328 300.506 328.834 300.98 328.036C301.175 327.708 301.067 327.283 300.738 327.087C300.409 326.893 299.984 327 299.789 327.329C299.563 327.708 299.149 327.943 298.71 327.943H294.368C293.677 327.943 293.115 327.381 293.115 326.69C293.115 325.999 293.677 325.437 294.368 325.437H299.519C300.445 325.437 301.316 324.941 301.789 324.144C301.984 323.814 301.876 323.389 301.547 323.195C301.216 322.996 300.792 323.107 300.598 323.436C300.369 323.822 299.965 324.051 299.519 324.051H293.927C293.236 324.051 292.674 323.488 292.674 322.797C292.674 322.106 293.236 321.544 293.927 321.544H300.333C301.259 321.544 302.129 321.049 302.603 320.252C302.798 319.923 302.69 319.498 302.361 319.303C302.031 319.108 301.607 319.216 301.412 319.544C301.183 319.929 300.779 320.158 300.333 320.158H293.752C293.061 320.158 292.499 319.596 292.499 318.905C292.499 318.214 293.061 317.651 293.752 317.651Z",
    fill: "#EE9547"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17876_123538",
    x: 32.485,
    y: -0.00130653,
    width: 233.542,
    height: 129.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.105882 0 0 0 0 0.278431 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17876_123538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17876_123538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_17876_123538",
    x: 129.86,
    y: 105.292,
    width: 101.333,
    height: 87.0837,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.9583
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.105882 0 0 0 0 0.278431 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17876_123538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17876_123538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_17876_123538",
    x: 186.86,
    y: 91.8337,
    width: 101.333,
    height: 87.0837,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.105882 0 0 0 0 0.278431 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17876_123538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17876_123538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_17876_123538",
    x: 243.86,
    y: 91.8337,
    width: 101.333,
    height: 87.0837,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.105882 0 0 0 0 0.278431 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17876_123538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17876_123538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_17876_123538",
    x: 32.485,
    y: 140.915,
    width: 161.5,
    height: 98.1667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.105882 0 0 0 0 0.278431 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17876_123538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17876_123538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_17876_123538",
    x: 0.8151,
    y: 235.915,
    width: 76.0002,
    height: 75.9997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.105882 0 0 0 0 0.278431 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17876_123538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17876_123538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_17876_123538",
    x: 32.485,
    y: 197.915,
    width: 207.417,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.105882 0 0 0 0 0.278431 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17876_123538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17876_123538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_17876_123538",
    x: 234.36,
    y: 269.165,
    width: 110.833,
    height: 110.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.105882 0 0 0 0 0.278431 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17876_123538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17876_123538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17876_123538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344.375,
    height: 380,
    fill: "white",
    transform: "translate(0.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastNoData);
export default __webpack_public_path__ + "static/media/broadcast-no-data.4c4864cd9de3f5eb211718c578514ce2.svg";
export { ForwardRef as ReactComponent };